import {autoserialize, autoserializeAs} from 'cerialize';
import {VehicleType} from './vehicle-type';

export class VehicleVehicleType {

  @autoserialize
  vehicleId: number;

  @autoserializeAs(VehicleType)
  vehicleType: VehicleType;

  @autoserialize
  active: boolean;

}
